import axios from "axios";
import { ticketBaseURL } from "../configs/api";

export const post_RdRentalSubscription = async (data: any, userId: number) => {
    const response = await axios({
        url: `${ticketBaseURL}rdRentalSubscription?userId=${userId}`,
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const getRdRentalSubscriptionByTenantId = (tenantId: string) => {
    return getFetch(`rdRentalSubscription/GetLatestRdRentalSubscriptionByTenantId,${tenantId}`)
}

const getFetch = async (url: string, params = {}) => {
    const response = await axios({
        url: ticketBaseURL + url,
        method: "GET",
        params: params
    });
    return response.data;
}